import { SAMPLE_REPORT_STATUSES } from '@/config/constants';

const advancedRevisionColumns = {
  labSampleCode: {
    key: 'labSampleCode',
    label: 'sampleId',
    type: 'text',
    sortable: 'custom',
    minWidth: 150,
  },
  sampleId: {
    key: 'sampleId',
    label: 'customerSampleId',
    type: 'text',
    sortable: 'custom',
    minWidth: 100,
  },
  customerProductName: {
    key: 'customerProductName',
    label: 'customerSampleCode',
    type: 'text',
    sortable: 'custom',
    minWidth: 120,
  },
  customerOrderNumber: {
    key: 'customerOrderNumber',
    label: 'customerOrderNumber',
    type: 'text',
    sortable: 'custom',
    minWidth: 100,
  },
  productCode: {
    key: 'productCode',
    label: 'productCode',
    type: 'text',
    sortable: 'custom',
    minWidth: 120,
  },
  productName: {
    key: 'productName',
    label: 'productName',
    type: 'text',
    sortable: 'custom',
    minWidth: 120,
  },
  lot: {
    key: 'lot',
    label: 'lot',
    type: 'text',
    sortable: 'custom',
    minWidth: 130,
  },
  acceptedAt: {
    key: 'acceptedAt',
    label: 'receivedDate',
    type: 'date',
    sortable: 'custom',
    minWidth: 170,
  },
  sampleAnalysisStart: {
    key: 'sampleAnalysisStart',
    label: 'sampleAnalysisStart',
    type: 'date',
    sortable: false,
    minWidth: 130,
  },
  sampleAnalysisEnd: {
    key: 'sampleAnalysisEnd',
    label: 'sampleAnalysisEnd',
    type: 'date',
    sortable: false,
    minWidth: 130,
  },
  sector: {
    key: 'sector',
    label: 'sector',
    type: 'enum',
    enum: 'sectors',
    sortable: 'custom',
    minWidth: 150,
  },
  laboratory: {
    key: 'laboratory',
    label: 'department',
    type: 'text',
    sortable: 'custom',
    minWidth: 100,
  },
  locationName: {
    key: 'locationName',
    label: 'location',
    type: 'text',
    sortable: false,
    minWidth: 150,
  },
  groupingId: {
    key: 'groupingId',
    label: 'grouping',
    type: 'text',
    sortable: 'custom',
    minWidth: 130,
  },
  orderId: {
    key: 'orderId',
    label: 'orderId',
    type: 'text',
    sortable: 'custom',
    minWidth: 130,
  },
  sampleReportCode: {
    key: 'sampleReportCode',
    label: 'reportCode',
    type: 'text',
    sortable: false,
    minWidth: 170,
  },
  sampleReportStatus: {
    key: 'sampleReportStatus',
    label: 'reportStatus',
    type: 'enum',
    enum: 'sampleReportStatuses',
    sortable: false,
    minWidth: 130,
  },
  lastReportDate: {
    key: 'lastReportDate',
    label: 'reportEmittedDate',
    type: 'datetime',
    sortable: 'custom',
    minWidth: 170,
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    minWidth: 160,
    buttons: [
      {
        name: 'viewReport',
        icon: 'fas fa-file-chart-line',
        permissions: ['advancedRevision'],
      },
      {
        name: 'advancedRevision',
        icon: 'fas fa-glasses',
        secondaryIcon: (row) => {
          if (row.sampleReportStatus === SAMPLE_REPORT_STATUSES.APPROVED) {
            return 'fas fa-glasses';
          }
          return row.sampleReportType === 'challenge'
            ? 'fas fa-file-signature'
            : 'fas fa-file-edit';
        },
        permissions: ['advancedRevision'],
      },
    ],
  },
};

export default advancedRevisionColumns;
